import React from 'react';

const Welcome = ({ onLogin }) => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-white flex flex-col items-center justify-center p-8">
            <div className="max-w-2xl text-center">
                <h1 className="text-4xl font-bold text-indigo-900 mb-6">
                    Welcome to Simple Bookmarks
                </h1>
                <p className="text-xl text-indigo-800 mb-8">
                    Your smart bookmark manager that makes organizing web content effortless.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left">
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-indigo-600 text-2xl mb-2">
                            <i className="fas fa-tags"></i>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Smart Tagging</h3>
                        <p className="text-gray-600">
                            Organize your bookmarks with intelligent tagging system. Search and filter with ease.
                        </p>
                    </div>
                    
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-indigo-600 text-2xl mb-2">
                            <i className="fas fa-cloud-upload-alt"></i>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Cloud Sync</h3>
                        <p className="text-gray-600">
                            Your bookmarks are safely stored in the cloud, accessible from anywhere.
                        </p>
                    </div>
                    
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-indigo-600 text-2xl mb-2">
                            <i className="fas fa-link"></i>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Link Health Check</h3>
                        <p className="text-gray-600">
                            Automatically verify your bookmarks' accessibility. Never encounter dead links again.
                        </p>
                    </div>
                    
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-indigo-600 text-2xl mb-2">
                            <i className="fas fa-file-import"></i>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Easy Import</h3>
                        <p className="text-gray-600">
                            Import your existing bookmarks from browsers with just one click.
                        </p>
                    </div>
                </div>

                <button 
                    onClick={onLogin} 
                    className="bg-indigo-600 text-white text-lg px-8 py-3 rounded-lg hover:bg-indigo-700 transition-colors shadow-lg flex items-center justify-center gap-2"
                >
                    <i className="fab fa-google"></i>
                    Sign in with Google
                </button>
            </div>
        </div>
    );
};

export default Welcome; 